import { FETCH_LISTS as fetchLists } from "../../../../../graphql/query/List";
import { multiSelect } from "../../../../../components/Functional";
import * as SelectList from "../../../../../components/Functional/SelectList";
import { LIST_TYPES } from "../../../../../constants/listTypes";
import EditableListName from "../../../../../components/Functional/SelectList/EditableListName";

const ListNameLink = props => {
  const { id, label } = props || {};
  const currentParams = new URLSearchParams(window.location.search);
  const nextParams = new URLSearchParams({
    status: "imageSelectListWorking",
    imageListId: id,
  });

  const listId = currentParams.get("listId");
  const workingListId = currentParams.get("workingListId");

  if (listId) {
    nextParams.set("listId", listId);
  } else if (workingListId) {
    nextParams.set("workingListId", workingListId);
  }

  return (
    <EditableListName
      id={id}
      label={label}
      to={`/artworks?${nextParams.toString()}`}
      typeId={LIST_TYPES.ARTWORK_IMAGE}
    />
  );
};

const Actions = props => {
  const { formik } = props || {};
  const actionProps = {
    ...props,
    ids: Object.keys(formik?.values?.selectedList?.ids || {})?.map(item =>
      parseInt(item.replace("_", "")),
    ),
    typeId: LIST_TYPES.ARTWORK_IMAGE,
  };

  return (
    <div className="grid grid-flow-col gap-4">
      <SelectList.DeleteList {...actionProps} />
    </div>
  );
};

const tableProps = props => {
  const { formik, imageListId } = props || {};

  const multiSelectProps = {
    formik,
    label: "Select List",
    name: "selectedList",
    keyName: "id",
  };

  const tableProps = {
    dataKey: "lists",
    headers: [
      multiSelect(multiSelectProps),
      {
        label: "List Name",
        name: "name",
        sortKey: "name",
        type: "custom",
        component: ListNameLink,
      },
      { label: "Instance Count", name: "itemsCount", type: "label" },
      { label: "Date / Time Last Updated", name: "updatedAt", type: "date" },
      {
        name: "action",
        type: "custom",
        component: props => (
          <SelectList.TableActions
            {...props}
            listKey={"imageListId"}
            preserveQueryKeys={["listId", "workingListId"]}
            typeId={LIST_TYPES.ARTWORK_IMAGE}
            statusKey={"imageSelectListWorking"}
          />
        ),
      },
    ],
    FETCH_QUERY: fetchLists(),
    variables: {
      typeId: LIST_TYPES.ARTWORK_IMAGE,
    },
    rowClassName: imageListId ? (row) => row?.id === imageListId ? "bg-blue-50" : "" : undefined,
  };

  return tableProps;
};

export { Actions, tableProps };
